<template lang="pug">
div
  v-snackbar(v-model="sbar_message" dark :timeout="2000") {{message}}
</template>
<script>
import { debug } from "@/api/logging"
import { ref, computed, watch, toRefs, defineComponent } from '@vue/composition-api'
import { message } from '@/api/states'

export default defineComponent({
  name: 'NotifyBars',
  props: {},
  emits: [],
  components: {},
  setup(props, {emit}) {

    const sbar_message = ref(false)
    watch([message], ()=>{
      if(!message.value) {
        sbar_message.value = false
      }
      else {
        sbar_message.value = true
      }
    })
    return {
      sbar_message, message,
    }
  },
})
</script>
